// <!-- From Uiverse.io by Pradeepsaranbishnoi --> 
import 'assets/css/loader.css'

const LoadingAnimation = () => {
    return (
        <div class="🤚">
                <div class="👉"></div>
                <div class="👉"></div>
                <div class="👉"></div>
                <div class="👉"></div>
                <div class="🌴"></div>
                <div class="👍"></div>
            </div>
    );
};

export default LoadingAnimation